import React, { Fragment } from 'react'
import BasePage from './BasePage';
import { connect } from 'react-redux';
import {setModalContent} from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import ClientSelector from '../components/ClientSelector.js';
import ArticleSelector from '../components/ArticleSelector.js';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';

import logo from '../img/logo-menu.png';
import ReactToPrint from 'react-to-print'

import $ from 'jquery';

class EditBill extends BasePage {

    loadOnConstructor(){
		this.getBillInterface = this.getBillInterface.bind(this);
		this.cancelButton = this.cancelButton.bind(this);
		this.saveButton = this.saveButton.bind(this);
		this.validateBillLines = this.validateBillLines.bind(this);
		this.updateBillCallback = this.updateBillCallback.bind(this);
		this.newBillCallback = this.newBillCallback.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.addArticle = this.addArticle.bind(this);
		this.parseResponse = this.parseResponse.bind(this);
		this.stringBackToStringFront = this.stringBackToStringFront.bind(this);
		this.initializeRefs = this.initializeRefs.bind(this);
		this.clientSelectedCallback = this.clientSelectedCallback.bind(this);
		this.articleSelectedCallback = this.articleSelectedCallback.bind(this);
		this.renderBillLines = this.renderBillLines.bind(this);
		this.renderLine = this.renderLine.bind(this);
		this.addLine = this.addLine.bind(this);
		this.dropLine = this.dropLine.bind(this);
		this.recalculateBillPrices = this.recalculateBillPrices.bind(this);
		this.renderTaxValues = this.renderTaxValues.bind(this);
		this.displayBillHeader = this.displayBillHeader.bind(this);
		this.displayBillBody = this.displayBillBody.bind(this);
		this.adjustDateToTimezone = this.adjustDateToTimezone.bind(this);
		this.convertToPdfDate = this.convertToPdfDate.bind(this);

		this.initializeRefs();

		const {bill_id, duplicate_id} = this.getUrlParams();
		if(bill_id !== undefined){
			this.state = {action: 'modify'};
			this.getBillInterface(bill_id);
		}else if(duplicate_id !== undefined){
			this.state = {action: 'duplicate'};
			this.getBillInterface(duplicate_id);
		}else{
			this.state = {action: 'new'};
			this.getBillInterface();
		}
    }

	initializeRefs(){
		this.clientSel = React.createRef();
		this.clientInput = React.createRef();

		this.clientInputValue = {};
		this.deletedClient = false;
		this.clientFromBill = false;

		this.articleSel = React.createRef();
		this.articleInput = React.createRef();

		this.articleInputValue = {};
		this.deletedArticle = false;
		this.articleFromBill = false;
	}

    getBillInterface(billId){
		const api = this.getApi();
		api.getEditBillInterface(billId, this.parseResponse);
    }

    parseResponse(response){
		if(response.hasOwnProperty('auth') && response.auth === false){
			this.navigateTo('/login');
			return;
		}

		if(response.status === 'OK'){
			if(this.state.action === 'modify' || this.state.action === 'duplicate'){

				if(this.state.action === 'modify'){
					response.bill.creation_date = this.stringBackToStringFront(response.bill.creation_date);
					response.bill.expiration_date = response.bill.expiration_date !== undefined?
					this.adjustDateToTimezone(response.bill.expiration_date, true):undefined
					
				}else if(this.state.action === 'duplicate'){
					delete response.bill.expiration_date
					delete response.bill.creation_date
					delete response.bill.status
					delete response.bookings
				}

				response.bill.client = response.bill.client._id

				response.bill.lines = response.bill.lines.map((line,idx) => {
					delete line._id
					if(line.article !== undefined && line.article !== null) {
						line.completeArticle = JSON.parse(JSON.stringify(line.article))
						line.article = line.completeArticle._id
					}
					return line
				})
				

				this.setState(prevState => {
					return {
						...prevState,
						bill: response.bill,
						selectedClient: response.selectedClient,
						taxes: response.taxes,
						operations: response.operations,
						bookings: response.bookings !== undefined?response.bookings:[],
						i18n: response.i18n
					}
				});
			}else{
				this.setState(prevState => {
					return {
						...prevState,
						bill: {lines:[{quantity:1}]},
						taxes: response.taxes,
						operations: response.operations,
						i18n: response.i18n
					}
				});
			}
		}else{
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		}
	}

	adjustDateToTimezone(dateObject, fromServer, toISOString){
		let modifiedDateObject = new Date(typeof dateObject === 'object'?dateObject.getTime():dateObject);
		let hoursFromTimezoneOffset = (modifiedDateObject.getTimezoneOffset()*-1) / 60;

		hoursFromTimezoneOffset = fromServer?hoursFromTimezoneOffset*-1:hoursFromTimezoneOffset

		modifiedDateObject.setHours(modifiedDateObject.getHours()+hoursFromTimezoneOffset);

		return toISOString?modifiedDateObject.toISOString():modifiedDateObject;
	}

	roundValues(originalValue){

		return Math.round(originalValue * 100) / 100
	}


	stringBackToStringFront(originalStr){
		const objDate = new Date(originalStr);

		return objDate.getUTCFullYear() + "-" +
			("0" + (objDate.getUTCMonth()+1)).slice(-2) + "-" +
			("0" + objDate.getUTCDate()).slice(-2) + " " +
			("0" + objDate.getUTCHours()).slice(-2) + ":" +
			("0" + objDate.getUTCMinutes()).slice(-2) + ":" +
			("0" + objDate.getUTCSeconds()).slice(-2);
	}

	convertToPdfDate(date, includeTime){
		const objDate = new Date(date);

		return ("0" + objDate.getUTCDate()).slice(-2) + '/' +
			("0" + (objDate.getUTCMonth()+1)).slice(-2) + '/' +
			objDate.getUTCFullYear() + 
				(includeTime?' '+("0" + objDate.getUTCHours()).slice(-2) + ":" +
				("0" + objDate.getUTCMinutes()).slice(-2) + ":" +
				("0" + objDate.getUTCSeconds()).slice(-2):'')
	}

	cancelButton(){
		this.goBack();
    }

    saveButton(){

		let failedValidators = {};
		const bill = this.state.bill

		if(bill.type === '' || bill.type === undefined){
			failedValidators.type = this.getTrad('fillBillType');
		}

		if(bill.client === '' || bill.client === undefined){
			failedValidators.client = this.getTrad('fillBillClient');
		}

		if(parseFloat(bill.type) === 1 && (bill.expiration_date === '' || bill.expiration_date === undefined)){
			failedValidators.expiration_date = this.getTrad('fillBillExpirationDate');
		}

		if(parseFloat(bill.type) === 2 && (bill.return_pay_bill === '' || bill.return_pay_bill === undefined)){
			failedValidators.return_pay_bill = this.getTrad('fillBillReturnPayBill');
		}

		if(bill.status === '0' || bill.status === undefined){
			failedValidators.status = this.getTrad('fillBillStatus');
		}

		if(bill.lines === undefined || bill.lines.length === 0){
			failedValidators.lines = this.getTrad('addAlmostOneLineToBill');
		}else{
			const errorsInLines = this.validateBillLines(bill.lines)
			if(errorsInLines.length > 0){
				errorsInLines.forEach((line, idx) => {
					let msgFields = ''
					for(const attr of line){
						msgFields += msgFields !== ''? ', '+this.getTrad(attr+'ErrorsInBillLine'):this.getTrad(attr+'ErrorsInBillLine')
					}
					failedValidators['line_'+idx] = this.getTrad('ErrorsInBillLine')+' '+(idx+1)+': '+msgFields
				})
			}
		}

		if(Object.keys(failedValidators).length !== 0){
			let message = [];
			for (let m in failedValidators){
				message.push(failedValidators[m]);
			}
			this.props.setModalContent({
				title: 'Debe completar los datos obligatorios',
				body: message,
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		} 
		
		let billToSend = JSON.parse(JSON.stringify(this.state.bill))

		billToSend.tax_values = JSON.stringify(this.state.bill.tax_values)
		billToSend.lines = JSON.stringify(this.state.bill.lines)

		if (parseFloat(this.state.bill.type) === 1){
			billToSend.expiration_date = this.adjustDateToTimezone(this.state.bill.expiration_date)
		
			const bookings = this.state.bookings === undefined?[]:JSON.parse(JSON.stringify(this.state.bookings))
			let bookingsToSend = bookings.map(booking => {
				if(booking) delete booking._id
				return booking
			})
			billToSend.bookings = JSON.stringify(bookingsToSend)
		}else{
			delete billToSend.expiration_date
		}

		if(this.state.action === 'duplicate'){
			delete billToSend._id
			delete billToSend.created_by_user
			delete billToSend.code
			delete billToSend.modification_date
			delete billToSend.modified_by_user
		}

		const api = this.getApi();
		if(this.state.action === 'modify'){
				api.updateBill(billToSend,this.updateBillCallback);
		}else{
				api.newBill(billToSend,this.newBillCallback);
		}
    }

	validateBillLines(lines){
		let errors = []
		const mandatoryFields = ['operation', 'unity_price', 'quantity', 'tax_type', 'description']
		//base_discount, line_total_price, quantity, unity_price, article, operation, base_price, tax_type, tax_price, 
		
		lines.forEach((line, index) => {
			for(const attr of mandatoryFields){
				if(line[attr] === undefined || line[attr] === null || line[attr] === '0' || line[attr] === ''){
					//Agregar error especifico para el campo undefined o null
					if(errors[index] === undefined) errors[index] = []
					errors[index].push(attr)
				}
			}

			//Comprobamos que las reservas esten completas y correctas
			if(this.state.bill.lines[index] !== undefined && this.state.bill.lines[index].article !== undefined &&
				(this.state.bookings[index] === undefined || this.state.bookings[index].article === undefined) 
			){
				if(errors[index] === undefined){
					errors[index] = []
				}
				errors[index].push('booking')
			}

		})

		return errors
	}

    updateBillCallback(response){
	    if(response.status === 'OK'){
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: ['La factura ha sido modificada satisfactoriamente.'],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			    ]
		    });

		    $("#exampleModal").modal('toggle');
	    }else{
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: [this.getTrad(response.message)],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true}
			    ]
		    });

		    $("#exampleModal").modal('toggle');
	    }
    }

    newBillCallback(response){
		if(response.status !== 'OK'){

			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true}
				]
			});

			$("#exampleModal").modal('toggle');

		}else{
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: ['La factura ha sido creada satisfactoriamente.'],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
				]
			});

			$("#exampleModal").modal('toggle');
		}
    }

    handleChange(event) {
		let billMod = this.state.bill?{...this.state.bill}:{};

		if(event.target === undefined){
			if(event.element && event.element.name === 'expiration_date'){
				billMod[event.element.name] = event.value;
			}

			this.setState(prevState => {
				return {
				...prevState,
				bill: billMod
			}});
		}else if(event.target.name.match(/^allowedTaxes_/)){
			const parts = event.target.name.split('_');
			billMod.allowed_taxes = billMod.allowed_taxes.filter((v, i, a) => a.indexOf(v) === i);
			if(event.target.checked){
				billMod.allowed_taxes.push(parts[1]);
			}else{
				billMod.allowed_taxes = billMod.allowed_taxes.filter(tax => tax !== parts[1]);
			}

			this.setState(prevState => {
				return {
				...prevState,
				bill: billMod
			}});
		}else if(event.target.name.match(/operation$/)){
			let nameParts = event.target.name.split("_")
			billMod.lines[nameParts[0]].operation = event.target.value !== '0'?event.target.value: undefined
			
			const operation = this.state.operations.filter(op => op._id === event.target.value)[0]
			
			let newTaxesForLines = this.state.taxesForLines?JSON.parse(JSON.stringify(this.state.taxesForLines)):[]
			newTaxesForLines[nameParts[0]] = operation !== undefined?this.state.taxes.filter(tx => operation.allowed_taxes.includes(tx._id)): this.state.taxes

			this.setState(prevState => {
				return {
					...prevState,
					taxesForLines: newTaxesForLines
				}
			}, this.recalculateLine(nameParts[0], billMod.lines[nameParts[0]]))
		}else if(event.target.name.match(/quantity$/)){
			let nameParts = event.target.name.split("_")
			billMod.lines[nameParts[0]].quantity = parseFloat(event.target.value)
			this.recalculateLine(nameParts[0], billMod.lines[nameParts[0]])
		}else if(event.target.name.match(/base_discount$/)){
			if(event.target.value === '') event.target.value = 0
			event.target.value = event.target.value.replace(/[a-zA-Z€]/g, '')
			event.target.value = event.target.value.replace(/[,]/g, '.')

			let nameParts = event.target.name.split("_")
			billMod.lines[nameParts[0]].base_discount = parseFloat(event.target.value)
			this.recalculateLine(nameParts[0], billMod.lines[nameParts[0]])
		}else if(event.target.name.match(/unity_price$/)){
			event.target.value = event.target.value.replace(/[a-zA-Z€]/g, '')
			event.target.value = event.target.value.replace(/[,]/g, '.')
			let nameParts = event.target.name.split("_")
			billMod.lines[nameParts[0]].unity_price = parseFloat(event.target.value)
			this.recalculateLine(nameParts[0], billMod.lines[nameParts[0]])
		}else if(event.target.name.match(/tax_type$/)){
			let nameParts = event.target.name.split("_")
			billMod.lines[nameParts[0]].tax_type = event.target.value
			this.recalculateLine(nameParts[0], billMod.lines[nameParts[0]])
		}else if(event.target.name.match(/description$/)){
			let nameParts = event.target.name.split("_")
			billMod.lines[nameParts[0]].description = event.target.value
			this.recalculateLine(nameParts[0], billMod.lines[nameParts[0]])
		}else{
			billMod[event.target.name] = typeof event.target.value === 'object'?{...event.target.value}:event.target.value;
			
			this.setState(prevState => {
				return {
				...prevState,
				bill: billMod
			}});
		}
    }

	recalculateLine(lineNumber, line){
		let taxType
		if(line.tax_type !== undefined){
			taxType = line.tax_type
		}
		if(line.operation !== undefined){
			const operation = this.state.operations.filter(op => op._id === line.operation)[0]
			if(taxType !== undefined){
				taxType = operation.allowed_taxes.includes(taxType)?taxType:operation.default_tax;
			}else{
				taxType = operation.default_tax;
			}
		}


		if(taxType !== undefined){
			line.tax_type = taxType
			const tax = this.state.taxes.filter(tx => tx._id === taxType)[0]

			$('#'+lineNumber+'_tax_type').val(taxType)

			if(line.quantity !== undefined && line.unity_price !== undefined){
				let basePrice = line.quantity*line.unity_price
				basePrice = line.base_discount !== undefined? basePrice - line.base_discount:basePrice
				line.base_price = basePrice
				line.tax_price = tax!== undefined?basePrice*(tax.value/100):0
				$('#'+lineNumber+'_tax_price').val(line.tax_price+"€")

				line.line_total_price = basePrice + line.tax_price
				$('#'+lineNumber+'_line_total_price').val(line.line_total_price+"€")
			}
		}

		this.recalculateBillPrices()
	}

	recalculateBillPrices(){
		let totalBasePrice = 0
		let totalBaseDiscount = 0
		let totalTaxes = 0

		let newBill = JSON.parse(JSON.stringify(this.state.bill));

		//Bucle general para conceptos no relacionados con impuestos
		this.state.bill.lines.forEach(line => {
			totalBasePrice += line.base_price !== undefined?line.base_price: 0
			totalBaseDiscount += line.base_discount !== undefined? line.base_discount: 0
		})

		//Solo para impuestos
		newBill.tax_values = this.state.taxes.map(tax => {
			let totalForTax = 0
			let totalBaseForTax = 0

			this.state.bill.lines.forEach(line => {
				if(tax._id === line.tax_type){
					totalForTax += line.tax_price !== undefined? line.tax_price: 0
					totalTaxes += line.tax_price !== undefined? line.tax_price: 0
					totalBaseForTax += line.base_price !== undefined? line.base_price: 0
				}
			})

			return totalForTax > 0 || totalForTax < -1?{name: tax.name, tax_type: tax._id, total_base: totalBaseForTax, total_tax: totalForTax}:undefined
		}).filter(tax => tax !== undefined && tax !== null)

		newBill.base_price = totalBasePrice;
		newBill.discount = totalBaseDiscount;
		newBill.total_price = totalBasePrice + totalTaxes;

		this.setState(prevState => {
			return {
				...prevState,
				bill: newBill
			}
		});
	}

	addClient(e){
		$("#client-selector-component").modal('toggle');
    }

	addArticle(e){
		const nameParts = e.target.name.split("_")
		const lineNumber = nameParts[0]
		this.setState(prevState => {
			return {
				...prevState,
				lineToModify: lineNumber
			}
		});

		const article = this.state.bill.lines[lineNumber].article
		const bookings = this.state.bookings?.filter(book => String(book.article) === String(article))

		const selectedBooking = {
			article: article,
			bookings: bookings,
			billCode: this.state.bill.code?this.state.bill.code:undefined,
			showAllArticles: parseFloat(this.state.bill.type) === 2? true: false
		}

		this.articleSel.current.setSelectedBooking(selectedBooking)

		$("#article-selector-component").modal('toggle')
    }

	clientSelectedCallback(clientSelected){
    	this.clientInputValue = clientSelected!== null?clientSelected.clients[0]:null;
    	this.deletedClient = this.clientInputValue === null?true:false;
    	this.clientInput.current.value = clientSelected!== null && this.clientInputValue?this.clientInputValue.name+' '+this.clientInputValue.lastname:'';
	
		if(clientSelected === null || clientSelected.clients[0] === null) clientSelected = undefined;

		let newBill = this.state.bill !== undefined? JSON.parse(JSON.stringify(this.state.bill)) : {}
		newBill.client = clientSelected !== undefined? clientSelected.clients[0]._id:undefined

		this.setState(prevState => {
			return {
				...prevState,
				selectedClient: clientSelected?clientSelected.clients[0]:undefined,
				bill: newBill
			}
		});
	}

	articleSelectedCallback(articleSelected){

    	this.articleInputValue = articleSelected.article!== null?articleSelected.article:null;
    	this.deletedArticle = this.articleInputValue === null?true:false;
		if(articleSelected === null || articleSelected.article === null) articleSelected = undefined;

		let newBill = JSON.parse(JSON.stringify(this.state.bill))
		newBill.lines[this.state.lineToModify].completeArticle = articleSelected !== undefined?articleSelected.article:''

		let newBookings = this.state.bookings?JSON.parse(JSON.stringify(this.state.bookings)):[]

		newBookings[this.state.lineToModify] = articleSelected?.article !== undefined?{
			article : articleSelected.article?._id,
			booking_status: parseFloat(articleSelected.status),
			start_date: this.adjustDateToTimezone(articleSelected.start_date, false, true),
			end_date: this.adjustDateToTimezone(articleSelected.end_date, false, true)
		}:{};

		this.setState(prevState => {
			return {
				...prevState,
				selectedArticle: articleSelected?articleSelected:undefined,
				lineToModify: undefined,
				bill: newBill,
				bookings: newBookings
			}
		});
	}

	addLine(){
		let newBill = this.state.bill !== undefined? JSON.parse(JSON.stringify(this.state.bill)) : {}
		if(newBill.lines !== undefined){
			newBill.lines.push({quantity:1})
		}else{
			newBill.lines = [{quantity:1}]
		}
		this.setState(prevState => {
			return {
				...prevState,
				bill: newBill
			}
		})
	}

	dropLine(e){
		let newBill = this.state.bill !== undefined? JSON.parse(JSON.stringify(this.state.bill)) : {}
		let nameParts = e.target.name.split("_")

		newBill.lines = this.state.bill.lines.filter((line,idx) => parseInt(idx) !== parseInt(nameParts[0]));
		
		this.setState(prevState => {
			return {
				...prevState,
				bill: newBill
			}
		}, this.recalculateBillPrices.bind(this))
		
	}

	generateRLKey(line, rlkey){
		let finalString = '';
		for(let key in line){
			finalString += line[key] + '_';
		}
		return finalString + rlkey;
	}

	renderLine(line, rlkey){

		let lineFromState = this.state.bill && this.state.bill.lines !== undefined && this.state.bill.lines[rlkey] !== undefined? this.state.bill.lines[rlkey]:{}
		lineFromState.article = lineFromState.completeArticle !== undefined?lineFromState.completeArticle._id:undefined

		return (
			<Fragment key={'rl_tr_fragment_'+this.generateRLKey(line, rlkey)} >
			<tr key={'rl_tr_1_'+this.generateRLKey(line, rlkey)}>
				<td>
					<button type="button" className="btn-xs btn-primary ml-2" 
					name={rlkey+"_drop_line"} id={rlkey+"_drop_line"} onClick={this.dropLine}>
					-
					</button>
					<select id={rlkey+'_operation'} name={rlkey+'_operation'}
				    defaultValue={lineFromState?lineFromState.operation:''} onChange={this.handleChange}>
						<option value="0">{this.getTrad("selectAnOption")}</option>
						{this.state.operations?this.state.operations.map(op => {
							return <option key={'rl_op_'+op._id} value={op._id}>{op.name}</option>
						}):undefined}
					</select>
				</td>
				<td>
					<input ref={this.articleInput} id={rlkey+'_article'} type="text" name={rlkey+'_article'} 
						readOnly  value={lineFromState && lineFromState.completeArticle?lineFromState.completeArticle.name:''}/>
					{parseFloat(this.state.bill?.type) === 1?<button className="btn btn-primary ml-1 pt-1 pb-1" id={rlkey+'_add_article'} name={rlkey+'_add_article'}
						onClick={this.addArticle} >{lineFromState.completeArticle && lineFromState.completeArticle !== ''?this.getTrad('modify'):this.getTrad('addArticle')}</button>:undefined}
				</td>
				<td>
					<input type='number' id={rlkey+'_quantity'} name={rlkey+'_quantity'} 
						defaultValue={lineFromState?lineFromState.quantity:1} onBlur={this.handleChange}
					className='text-right' />
				</td>
				<td>
					<input type='text' id={rlkey+'_unity_price'} name={rlkey+'_unity_price'} 
					defaultValue={lineFromState && lineFromState.unity_price!== undefined?lineFromState.unity_price+"€":''} onBlur={this.handleChange}
					className='text-right' />
				</td>
			</tr>
			<tr key={'rl_tr_2_'+this.generateRLKey(line, rlkey)}>
				<td>
					<input type='text' id={rlkey+'_base_discount'} name={rlkey+'_base_discount'} 
					defaultValue={lineFromState && lineFromState.base_discount!== undefined?lineFromState.base_discount+"€":''} onBlur={this.handleChange} 
					className='text-right' />
				</td>
				<td>
					<select id={rlkey+'_tax_type'} name={rlkey+'_tax_type'} onChange={this.handleChange}
						defaultValue={lineFromState?lineFromState.tax_type:''} >
						<option value="0">{this.getTrad("selectAnOption")}</option>
						{this.state.taxesForLines && this.state.taxesForLines[rlkey]?this.state.taxesForLines[rlkey].map((tax,idx) => {
							return <option value={tax._id} key={'tax_'+rlkey+'_'+idx}>
								{tax.name}
							</option>
						}):this.state.taxes?this.state.taxes.map((tax,idx) => {
							return <option value={tax._id} key={'tax_'+rlkey+'_'+idx}>
								{tax.name}
							</option>
						}):''
						}
					</select>
				</td>
				<td>
					<input readOnly type='text' id={rlkey+'_tax_price'} name={rlkey+'_tax_price'} 
					value={lineFromState && lineFromState.tax_price!== undefined?
						this.roundValues(lineFromState.tax_price)+"€":''} className='text-right' />
				</td>
				<td>
					<input readOnly type='text' id={rlkey+'_line_total_price'} name={rlkey+'_line_total_price'} 
					value={lineFromState && lineFromState.line_total_price!== undefined?
						this.roundValues(lineFromState.line_total_price)+"€":''} className='text-right' />
				</td>
			</tr>
			<tr key={'rl_tr_3_'+this.generateRLKey(line, rlkey)}>

				<td colSpan="6">
				<input type='text' className="form-control" id={rlkey+'_line_description'} 
					name={rlkey+'_line_description'} onBlur={this.handleChange}
					defaultValue={lineFromState && lineFromState.description?lineFromState.description:''} />
				</td>
			</tr>
			</Fragment>
		)
		
	}

	renderBillLines(){

		return (
			<>
				<button type="button" className="btn-xs btn-primary ml-2" 
				name="add_line" id="add_line" onClick={this.addLine}>
				+
				</button>
				{/* Boton para ver el estado */}
				{/*}
				<button type="button" className="btn-xs btn-primary ml-2" 
				name="aaa" id="aaa" onClick={this.verState}>
				?
				</button>
				{*/}
				<div className="row">
					<div className="col-12">

						<table className="table table-striped table-hover">
							<thead>
								<tr>
									<td>{this.getTrad('Operation')}</td>
									<td>{this.getTrad('Article')}</td>
									<td>{this.getTrad('Quantity')}</td>
									<td>{this.getTrad('UnityPrice')}</td>
								</tr>
								<tr>
									<td>{this.getTrad('BaseDiscount')}</td>
									<td>{this.getTrad('TaxType')}</td>
									<td>{this.getTrad('TaxPrice')}</td>
									<td>{this.getTrad('LineTotalPrice')}</td>
								</tr>	
								<tr>
									<td colSpan="4">{this.getTrad('LineDescription')}</td>
								</tr>
							</thead>
							<tbody>
								{this.state.bill && this.state.bill.lines?this.state.bill.lines.map((line, idx) => {
									return this.renderLine(line, idx);
								}):this.renderLine(undefined, 0)}
							</tbody>
						</table>
					</div>
				</div>
			</>
		)
	}

	renderTaxValues(){	

		return <div className="form-group">
					<label>Impuestos</label>
					<table className='table'>
						<thead>
						<tr>
							<td>Tipo</td>
							<td className='text-right'>Base</td>
							<td className='text-right'>Valor</td>
						</tr>
						</thead>
						<tbody>
						{this.state.bill && this.state.bill.tax_values.length>0?this.state.bill.tax_values.map(tval => {
							return tval !== undefined && tval !== null?(<tr key={'taxes_'+tval.name}>
								<td>{tval.name}</td>
								<td className="text-right">{this.roundValues(tval.total_base)+"€"}</td>
								<td className="text-right">{this.roundValues(tval.total_tax)+"€"}</td>
							</tr>):''
						}):'' }
						</tbody>
					</table>
				</div>
	}

	displayBillHeader(){
		return (
			<>
			<div className='row'>
				<div className='col-6' style={{marginTop:'20px'}}>
					<span style={{fontSize: '50px', marginLeft:'30px'}}>
						<img alt="Logo" src={logo} width="250" />
					</span>
				</div>
				<div className='col-6 text-right'>
					<div style={{width:'100%', paddingRight:'30px'}}>
						<h2 style={{color: '#b9d9fd'}}>{this.state.bill && parseFloat(this.state.bill.type) === 1?
							'Factura de venta':'Factura rectificativa'}</h2>
						<div style={{display:'block', paddingRight:'15px'}} className='row text-right'>
							<span className='font-weight-bold'>Fecha de factura</span> 
							{this.state.bill?' '+this.convertToPdfDate(this.state.bill.creation_date):''}
							</div>
						{this.state.bill && this.state.bill.expiration_date !== undefined?
						<div style={{display:'block', paddingRight:'15px'}} className='row text-right'>
							<span className='font-weight-bold'>Plazo</span> 
							{this.state.bill?' '+this.convertToPdfDate(this.state.bill.expiration_date):''}
						</div>:''}
						{this.state.selectedClient?.dni?
						<div style={{display:'block', paddingRight:'15px'}} className='row text-right'>
							<span className='font-weight-bold' style={{marginRight: '8px'}}>Su Nif</span> 
							{this.state.selectedClient.dni}
						</div>:''}
						<div style={{display:'block', paddingRight:'15px'}} className='row text-right'>
							<span className='font-weight-bold'>{this.getTrad('billCode')}</span> {this.state.bill?this.state.bill.code:''}
						</div>
					</div>
				</div>
			</div>
			<div className='row'>
				<div className='col-5'>
					<div style={{marginLeft:'30px', lineHeight:'1'}}>
						<h2 style={{marginLeft:'15px'}}>ACCEDIENDO SLU</h2>
						<div style={{marginLeft:'15px', lineHeight:'1'}} className='row'>CERRO DE VALDECAHONDE 6, 2ºD</div>
						<div style={{marginLeft:'15px'}} className='row'>MADRID, 28023</div>
						<div style={{marginLeft:'15px'}} className='row'>Spain</div>
						<div style={{marginLeft:'15px', marginTop:'10px'}} className='row'>NIF ES B87258125</div>
						<div style={{marginLeft:'15px', marginTop:'10px'}} className='row'>www.accedan.com</div>
						<div style={{marginLeft:'15px'}} className='row'>608583106</div>
						<div style={{marginLeft:'15px'}} className='row'>910 532 374</div>
						<div style={{marginLeft:'15px'}} className='row'>INFO@ACCEDAN.COM</div>
					</div>
				</div>
				<div className='col-6'>
							<div style={{marginTop:'50px'}} className='row'>
								{this.state.selectedClient?this.state.selectedClient.name+' '+this.state.selectedClient.lastname:''}
							</div>
							<div className='row'>
								{this.state.selectedClient?this.state.selectedClient.complete_direction:''}
							</div>
				</div>
			</div>
			</>				
		)
	}

	displayBillBody(){
		return (
			<>
			<div className='row'>
				<div className='col-12'>
					<table className='table' style={{marginLeft:'30px', marginTop: '50px', width:'95%'}}>
						<thead  className='font-weight-bold'>
							<tr>
								<th style={{width:'50%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>{this.getTrad('LineDescription')}</th>
								<th className='text-right' style={{width:'10%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>{this.getTrad('Cant./Horas')}</th>
								<th className='text-right' style={{width:'15%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>{this.getTrad('Precio/unidad')}</th>
								<th className='text-center' style={{width:'10%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>{this.getTrad('IVA %')}</th>
								<th className='text-right' style={{width:'15%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>{this.getTrad('Base imponible')}</th>
							</tr>
						</thead>
						<tbody>
							{this.state.bill?this.state.bill.lines.map((line,idx) => {
								const tax = this.state.taxes.filter(tax => tax._id === line.tax_type)
								return (<tr key={'pdf_line_'+idx}>
										<td>{line.description}</td>
										<td className='text-right'>{parseFloat(line.quantity).toFixed(2)}</td>
										<td className='text-right'>{parseFloat(line.unity_price).toFixed(2)}</td>
										<td className='text-center'>{tax[0]!== undefined?parseFloat(tax[0].value).toFixed(2):''}</td>
										<td className='text-right'>{parseFloat(line.base_price).toFixed(2)}</td>
									</tr>
								)
							}):undefined}

						</tbody>
					</table>
				</div>
			</div>
			<div className='row mt-5'>
				<div className='col-5'>
					<div style={{marginLeft:'60px'}}>
						<div className='row font-weight-bold' style={{fontSize:'20px'}}>{this.getTrad('billLegalText1')}</div>
						<div className='row'>{this.getTrad('billLegalText2')}</div>
						<div className='row'>{this.getTrad('billLegalText3')}</div>
						<div className='row'>{this.getTrad('billLegalText4')}</div>
						<div className='row'>{this.getTrad('billLegalText4.1')}</div>
						<div className='row font-weight-bold mt-3' style={{fontSize:'20px'}}>{this.getTrad('billLegalText5')}</div>
						<div className='row'>{this.getTrad('billLegalText6')}</div>
						<div className='row'>{this.getTrad('billLegalText7')}</div>
					</div>
				</div>
				<div className='col-7'>
					<table className='table' style={{marginLeft:'100px', width:'80%'}}>
						<thead>
							<tr>
								<th className='text-right' style={{width:'50%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>Base imponible</th>
								<th className='text-right' style={{width:'50%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>Tipo de IVA</th>
								<th className='text-right' style={{width:'50%', borderTop:'0px', borderBottom:'1px solid #b9d9fd'}}>Total</th>
							</tr>
						</thead>
						<tbody>
							{this.state.bill && this.state.bill.tax_values?this.state.bill.tax_values.map((taxLine,idx) => {
								
								return (<tr key={'pdf_tax_values'+idx}>
									<td className='text-right'>{parseFloat(taxLine.total_base).toFixed(2)}</td>
									<td className='text-right'>{taxLine.name}</td>
									<td className='text-right'>{parseFloat(taxLine.total_tax).toFixed(2)}</td>
								</tr>)
							}):undefined}
						</tbody>
					</table>
					<div className='row font-weight-bold text-right' style={{backgroundColor: '#b9d9fd', marginLeft:'100px', width: '80%', lineHeight:'5'}}>
						<div className='col-7'>
							Total
						</div>
						<div className='col-5'>{this.state.bill?parseFloat(this.state.bill.total_price).toFixed(2)+'€':''}</div>
					</div>
				</div>
			</div>
			</>
		)
	}

    render(){
		
        return (
			<>
			{/*<button onClick={() => {this.verState()}}>Ver state</button>*/}
            <div className="container">
            	<Menu />
                <h3>{this.state.action === 'new'?this.getTrad('billInsertion'):this.getTrad('billEdition')}</h3>
                <div className="row mt-4">
			<div className="col-12">
			
			{(this.state.bill || this.state.action === 'new')?
				<>
				  {this.state.bill?.creation_date?
				  <>
					<div className="form-group">
						<label htmlFor="creation_date">Fecha de emisión</label>
						<input id="creation_date" name="creation_date" className="form-control" readOnly
						value={this.convertToPdfDate(this.adjustDateToTimezone(this.state.bill.creation_date))} />
					</div>
					<div className="form-group">
						<label htmlFor="code">Código de factura</label>
						<input id="code" name="code" className="form-control" readOnly
						value={this.state.bill.code} />
					</div>
				  </>:''
				  }

				  <div className="form-group">
				    <label htmlFor="type">Tipo factura</label>
				    <select className="form-control" id="type" name="type"
				    defaultValue={this.state.bill?this.state.bill.type:''} onChange={this.handleChange}>
						<option value="0">{this.getTrad("selectAnOption")}</option>
						<option value="1">{this.getTrad("getPaidBill")}</option>
						<option value="2">{this.getTrad("returnPayBill")}</option>
						{/*}<option value="1" selected={this.state.bill && this.state.bill.tax === tax._id?true:undefined}>{tax.name}</option>{*/}
					</select>
				  </div>
				  {this.state.bill && parseFloat(this.state.bill.type) === 2?
				  <div className="form-group">
				    <label htmlFor="name">Factura que rectifica</label>
					<input value={this.state.bill?this.state.bill.return_pay_bill:undefined}
						id="return_pay_bill" type="text" name="return_pay_bill" className="form-control" onChange={this.handleChange} />
				  </div>:''}
				  <div className="form-group">
				    <label htmlFor="name">Cliente</label>
					<input ref={this.clientInput} id="clientName" value={this.state.selectedClient?this.state.selectedClient.name+' '+this.state.selectedClient.lastname:undefined}
						type="text" name="clientName" readOnly className="form-control" />
					<input id="client" type="hidden" name="client"/> 
					<button className="btn btn-primary" onClick={this.addClient} >{this.state.selectedClient?"Cambiar cliente":"Agregar cliente"}</button>
				  </div>

				  {(this.state.bill && parseFloat(this.state.bill.type) === 1) || this.state.bill === undefined 
				  	|| this.state.bill.type === undefined?
				  <div className="form-group">
				    <label htmlFor="expiration_date">Fecha vencimiento</label>
				  	<DateTimePickerComponent format='dd/MM/yy hh:mm a' id="expiration_date" 
					  value={this.state.bill?new Date(this.state.bill.expiration_date):undefined} change={this.handleChange} />
				  </div>
				  :''}

				  <div className="form-group">
				    <label htmlFor="status">Estado</label>
				    <select className="form-control" id="status" name="status"
				    defaultValue={this.state.bill?this.state.bill.status:''} onChange={this.handleChange}>
						<option value="0">{this.getTrad("selectAnOption")}</option>
						<option value="1">{this.getTrad("pendingBillStatus")}</option>
						<option value="2">{this.getTrad("overdueBillStatus")}</option>
						<option value="3">{this.getTrad("collectedBillStatus")}</option>
						<option value="4">{this.getTrad("unpaidBillStatus")}</option>
						<option value="5">{this.getTrad("returnedPayBillStatus")}</option>
						{/*}<option value="1" selected={this.state.bill && this.state.bill.tax === tax._id?true:undefined}>{tax.name}</option>{*/}
					</select>
				  </div>
				  <div className="form-group">
				  	<label>{this.getTrad('Lines')}</label>
					{this.renderBillLines()}
				  </div>

				  <div className="form-group">
				    <label htmlFor="base_price">Base imponible</label>
				    <input type="text" readOnly className="form-control" id="base_price" name="base_price"
				    value={this.state.bill && this.state.bill.base_price!== undefined?this.roundValues(this.state.bill.base_price)+"€":''} />
				  </div>
				  {this.state.bill !== undefined && this.state.bill.tax_values !== undefined && this.state.bill.tax_values.length>0?
				  this.renderTaxValues():''}
				  <div className="form-group">
				    <label htmlFor="total_price">Importe final</label>
				    <input type="text" readOnly className="form-control" id="total_price" name="total_price"
				    value={this.state.bill && this.state.bill.total_price!== undefined?
					this.roundValues(this.state.bill.total_price)+"€":''} />
				  </div>

				  <div className="d-flex justify-content-between align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={this.saveButton}>Guardar</button>
					  {this.state.bill && this.state.bill.code !== undefined?<ReactToPrint
					  	onBeforePrint={() => {document.title = this.state.bill && this.state.bill.code !== undefined?this.state.bill.code.replace(/\//g, '_'):"CRM Accedan"}}
					  	onAfterPrint={() => {document.title = "CRM Accedan"}}
						trigger={() => {
							return (
								<button type="button" className="btn btn-primary">Imprimir</button>
								)
						}}
						content={() => this.componentRef}
						/>:''}
					  <button type="button" className="btn btn-secondary" onClick={this.cancelButton}>Cancelar</button>
				  </div>
				</>

			:<span>...</span>}

			</div>
            </div>
			
			<ClientSelector ref={this.clientSel} onClientSelected={this.clientSelectedCallback}  />
			<ArticleSelector 
				ref={this.articleSel} 
				onArticleSelected={this.articleSelectedCallback} 
			/>
			<Modal />
            </div>

			{/* COMIENZO Documento para imprimir factura en PDF */}
			<div style={{display:'none'}}> 
				<div ref={el => (this.componentRef = el)}>
					{this.displayBillHeader()}
					{this.displayBillBody()}
				</div>
			</div>
			{/* FIN Documento para imprimir factura en PDF */}
			</>
        );
    }
}

const mapStateToProps = state => {
    return {
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
	    	dispatch(setModalContent(modalContent));
		}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditBill)
